import { render, staticRenderFns } from "./assetInventoryEditList.vue?vue&type=template&id=88b86704&scoped=true"
import script from "./assetInventoryEditList.vue?vue&type=script&lang=js"
export * from "./assetInventoryEditList.vue?vue&type=script&lang=js"
import style0 from "./assetInventoryEditList.vue?vue&type=style&index=0&id=88b86704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b86704",
  null
  
)

export default component.exports